module.exports = __webpack_public_path__ + "img/1.090cd9f6.jpg";